import Vue from 'vue'

const API_BASE_URL = window.globalConfig.apiUrl
Vue.prototype.$apiPrifixUri = API_BASE_URL
export default {
  baseURL: API_BASE_URL,
  loginUrl: '/UserLoginServlet',
  pointListUrl: '/IndexRequest',
  worksheetUrl: '/LadingServlet',
  deviceListUrl: '/DevicesRequest',
  enginnerUrl: '/EngineerServlet',
  customerUrl: '/CustomerServlet',
  personalUrl: '/PersonServlet',
  orderUrl: '/TabWorkServlet',
  reportUrl: '/ReportServlet?random=' + (new Date()).getTime(),
  assetUrl: '/WareServlet',
  monitorUrl: '/Monitor',
  topoUrl: '/newTopo',
  authUrl: '/NewBasesnsServlet',
  chatNameUrl: '/ChatNameServlet',
  logoutUrl: '/UserLogoutServlet'
}






// WEBPACK FOOTER //
// ./src/service/url.js